import { IRawVariant, IVariant } from 'models/variant.model'

export const getVariantFromRawVariant = (
  rawVariant: IRawVariant,
): IVariant => ({
  cohort: rawVariant.cohort_id,
  facebookPixelId: rawVariant.facebook_pixel_id,
  optimizeMap: rawVariant.optimize_map,
  optimizeExperimentMap: rawVariant.optimize_experiments,
  pinterestTagId: rawVariant.pinterest_tag_id,
  hasCancelOffer: rawVariant.has_cancel_offer,
  abSegmentName: rawVariant.ab_segment_name,
})
